// Centralized brand asset URLs with CDN-aware fallback
// Prefer explicit VITE_CORE_LOGO_URL; else build from VITE_CDN_URL; else fallback to local public asset
const cdn = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_CDN_URL) || '';
const explicit = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_CORE_LOGO_URL) || '';

function trimSlash(s = '') { return s.replace(/\/$/, ''); }

export const CORE_LOGO_URL = explicit
  || (cdn ? `${trimSlash(cdn)}/branding/authenticated_with_core.png` : '/authenticated_with_core.png');

